import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=186a63d8&scoped=true&"
import script from "./shop.vue?vue&type=script&lang=ts&"
export * from "./shop.vue?vue&type=script&lang=ts&"
import style0 from "./shop.vue?vue&type=style&index=0&id=186a63d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186a63d8",
  null
  
)

export default component.exports